/**
 * Create an UUID function
 *
 * @return ランダムな文字列
 */
/* eslint-disable */
const createUUID = function () {
  console.debug('*** Start *** createUUID')
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export default createUUID



// WEBPACK FOOTER //
// ./src/functions/createUUID.js